<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Set Standard Admission Fee
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="std_config_list!=''">
             <v-row dense>
                <v-col cols="12" sm="5" md="5" style="text-align: right;">
                    <v-autocomplete rounded dense required v-model="from_std" :items="std_copy_list" item-value="sid" item-text="standard" label="From Standard" outlined />
                </v-col>
                <v-col cols="12" sm="2" md="2" style="text-align: center;">
                    <v-btn text color="#0f2027" :loading="copy_btn_load">
                        <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="5" md="5" style="text-align: left;">
                    <v-autocomplete rounded dense required v-model="to_std" multiple :items="std_copy_list" item-value="sid" item-text="standard" label="To Standard" outlined />
                </v-col>
            </v-row>
             <v-row dense justify="center">
                <v-btn :loading="copy_offer_btn_load" @click="copySemConfig()" class="button">Copy</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th class="">Sr. No.</th>
                            <th class="">Standard</th>
                            <th class="">Start Date (Inclusive)</th>
                            <th class="">End Date  (Exclusive)</th>
                            <th class="">Fees</th>
                            <th>Save / Update</th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="(s,index) in std_config_list" :key="s.sid">
                            <td>{{index+1}}</td>
                            <td>{{s.standard}}</td>
                            <td><input id="datePickerId" type="date" v-model="s.start_date" /></td>
                            <td><input id="datePickerId" type="date" v-model="s.end_date" /></td>
                            <td><input type="number" dense v-model="s.fee"></td>
                            <td>
                                <v-btn small class="button" :disabled="s.start_date == null || s.end_date == null" @click="saveSingleAdmissionFee(s.sid,s.ay_id,s.start_date,s.end_date,s.fee)">Save / Update</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn :loading="loader" small @click="saveAllFeesConfig(std_config_list)" class="button">Save / Update</v-btn></center>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                ay_std_div_list: null,
                sel_ay_data: null,
                ay_id: null,
                std_config_list: [],
                sem_list: [],
                loader: false,
                std_copy_list: [],
                from_std: null,
                to_std: [],
                copy_offer_btn_load: false,
            };
        },
        methods: {
             copySemConfig() {
                for (var i = 0; i < this.to_std.length; i++) {
                    if (this.from_std == this.to_std[i]) {
                        this.showSnackbar("#b71c1c", "From and To Standard cannot be same!!!...");
                        return;
                    }
                }
                this.copy_offer_btn_load = true;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    from_std: this.from_std,
                    to_std: this.to_std,
                };
                axios
                    .post("/Academics/copyFeeConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Copied Successfully..."); // show snackbar on success
                            this.onload();
                            this.copy_offer_btn_load = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                            this.copy_offer_btn_load = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.copy_offer_btn_load = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.copy_offer_btn_load = false;
                    })
                    .finally(() => {
                        this.copy_offer_btn_load = false;
                        (this.from_std = null), (this.to_std = []);
                    });
            },
            saveAllFeesConfig(std_config_list){
                const data = {
                   std_config_list:std_config_list
                }
                this.loader = true
                axios
                    .post("/Academics/saveAllFeesConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                         this.loader = false
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = true
                    })
                    .finally(() => {
                       
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            saveSingleAdmissionFee(sid,ay_id,start_date,end_date,fee){
                const data = {
                    sid:sid,
                    ay_id:ay_id,
                    start_date:start_date,
                    end_date:end_date,
                    fee:fee
                }
                axios
                    .post("/Academics/saveSingleAdmissionFee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                       
                    })
                    .finally(() => {
                       
                    });
            },
            onload() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                this.overlay = true;
                axios
                    .post("/Academics/getAdmissionFeeConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.std_copy_list = res.data.std_copy_list;
                            this.std_config_list = res.data.std_config_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            main() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.main();
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    input[type="number"] {
        width: 70%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
